export default __webpack_public_path__ + "static/media/AKM_3.f1b6892f.png";